import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from "src/app/servizi/utils.service";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from "rxjs/operators";
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-solr-autocomplete',
  templateUrl: './solr-autocomplete.component.html',
  styleUrls: ['./solr-autocomplete.component.scss']
})
export class SolrAutocompleteComponent implements OnInit {

  // Placeholder
  @Input() placeholder_: string = '';

  // Tooltip
  @Input() ngbTooltip_: string = '';

  // Tooltip placement
  @Input() placement_: string = '';

  // Research button visibility
  @Input() btnSearch: boolean = false;

  // SOLR Core
  @Input() filter: Array<string> = [];

  // To format the data retrieved from the Solr core (List of items)
  @Input() resultFormatter_;

  // To format te selected object (Input element)
  @Input() inputFormatter_;

  // Event emitter to emit the selected object
  @Output() selectedItemEvent = new EventEmitter<any>();

  // Event emitted when the research button is clicked
  @Output() selectedItemClickEvent = new EventEmitter<any>();

  // Selected item model
  selectedItem;

  // Solr search url
  private solrSearchUrl = this.utilsService.creaURL("restrictedArea", "search");

  /** Icons FA */
  icons: any = {
    faSearch,
  };

  /** Constructor */
  constructor(private utilsService: UtilsService) { }

  /** OnInit */
  ngOnInit(): void {}

  /**
   * Function called when typing in the input field.
   * term is the string to search 
   * filter is the Solr core
   */
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term => this.solrSearch(term, this.filter)),
      map( res => !res.data || res.data.length === 0 ? [] : res.data)
  )


  /**
  * Observable that implements the Solr search (Call the Solr search API)
  */
  solrSearch(term: string, filter?:any): Observable<any> {

    var innerObservable =  new Observable<any>();

    var params = {
      term: [term],
      filter: filter 
    };

    if(term !== ''){
      innerObservable = this.utilsService.getRequest(this.solrSearchUrl, params) as Observable<any>;
    }

    return innerObservable;
  }


  /** Function called when an item is selected from the list */
  onSelectedItem(event: NgbTypeaheadSelectItemEvent){
    // console.log("selectedItemEvent.emit---> ", this.selectedItem, event.item);
    this.selectedItemEvent.emit(event.item);
  }

  /** Function called when the search button is clicked */
  onSearchItemClick(event: NgbTypeaheadSelectItemEvent){
    // console.log("selectedItemClickEvent.emit---> ", this.selectedItem, event.item);
    this.selectedItemClickEvent.emit(this.selectedItem)
  }

  /** To get the selected item */
  getSelectedItem(){
    return this.selectedItem;
  }

  /** To set the selected item */
  setSelectedItem(item){
    this.selectedItem = item;
    // console.log("setSelectedItem.emit---> ", this.selectedItem);
    this.selectedItemEvent.emit(this.selectedItem);
  }

  /** To reset the selected item */
  resetSelectedItem(){
    this.selectedItem = undefined;
    // console.log("resetSelectedItem.emit---> ", this.selectedItem);
    this.selectedItemEvent.emit(this.selectedItem);
  }
}
